import hardtack from 'hardtack';

export function getLoggedIn(): boolean {
  return hardtack.get('REF') !== undefined;
}
